// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"SystemSettingBlock--next-sr-only--3CK5Wko","switchWidth":"SystemSettingBlock--switchWidth--1K269nd"};